<div *ngIf="!!reportData">
    <div class="card">
        <!-- Servicekontrakt -->
        <div class="row">
            <div class="col-12">
                <h3>Servicekontrakt</h3>
            </div>
            <div class="col-6 col-md">
                <label for="assetServiceAgreementType">Serviceaftale</label>
                <div class="mt-1" id="assetServiceAgreementType">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="assetServiceAgreementType" id="assetServiceAgreementTypeB" [checked]="reportData.assetServiceAgreementType == 'Basis'" (click)="reportData.assetServiceAgreementType = 'Basis'; saveDoc()" [disabled]="isLocked">
                        <label class="form-check-label" for="assetServiceAgreementTypeB">Basis</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="assetServiceAgreementType" id="assetServiceAgreementTypeE" [checked]="reportData.assetServiceAgreementType == 'Udvidet'" (click)="reportData.assetServiceAgreementType = 'Udvidet'; saveDoc()" [disabled]="isLocked">
                        <label class="form-check-label" for="assetServiceAgreementTypeE">Udvidet</label>
                    </div>
                </div>
            </div>
            <div class="col-6 col-md">
                <label for="assetInstaller">Installationsfirma</label>
                <input type="text" class="form-control" id="assetInstaller" [(ngModel)]="reportData.assetInstaller" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
            <div class="col-6 col-md">
                <label for="assetServiceAgreement">Serviceinterval</label>
                <div class="mt-1" id="assetServiceAgreement">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="serviceAgreement" id="serviceAgreement1" [checked]="reportData.assetServiceAgreement == '1'" (click)="reportData.assetServiceAgreement = '1'; saveDoc()" [disabled]="isLocked">
                        <label class="form-check-label" for="serviceAgreement1">1-årigt</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="serviceAgreement" id="serviceAgreement2" [checked]="reportData.assetServiceAgreement == '2'" (click)="reportData.assetServiceAgreement = '2'; saveDoc()" [disabled]="isLocked">
                        <label class="form-check-label" for="serviceAgreement2">2-årigt</label>
                    </div>
                </div>
            </div>
            <div class="col-6 col-md">
                <label for="assetStartDate">Opstartsdato</label>
                <input type="date" class="form-control" id="assetStartDate" [(ngModel)]="reportData.assetStartDate" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
        </div>
        <hr>
        <!-- Anlægsadresse -->
        <div class="row">
            <div class="col-12">
                <h3>Anlægsadresse</h3>
            </div>
            <div class="col-12 col-md pr-md-0">
                <label for="assetAddress">Adresse</label>
                <input type="text" class="form-control" id="assetAddress" [(ngModel)]="reportData.assetAddress" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
            <div class="col-4 col-md-auto">
                <label for="assetZipCode">Postnr.</label>
                <input type="text" class="form-control" id="assetZipCode" [(ngModel)]="reportData.assetZipCode" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
            <div class="col-8 col-md pl-0">
                <label for="assetCity">By</label>
                <input type="text" class="form-control" id="assetCity" [(ngModel)]="reportData.assetCity" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
        </div>
        <hr>
        <!-- Kundeoplysninger -->
        <div class="row">
            <div class="col-12">
                <h3>Kundeoplysninger</h3>
            </div>
            <div class="col-12 col-md pr-md-0">
                <label for="customerName">Navn</label>
                <input type="text" class="form-control" id="customerName" [(ngModel)]="reportData.customer.name" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
            <div class="col-12 col-md-auto">
                <label for="customerPhone">Telefon</label>
                <input type="text" class="form-control" id="customerPhone" [(ngModel)]="reportData.customer.phone" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
            <div class="col-12 col-md pl-md-0">
                <label for="customerEmail">Email</label>
                <input type="text" class="form-control" id="customerEmail" [(ngModel)]="reportData.customer.email" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
        </div>
        <hr>
        <!-- Kundeadresse -->
        <div class="row">
            <div class="col-12">
                <h3>Kundeadresse</h3>
            </div>
            <div class="col-12 col-md pr-md-0">
                <label for="customerAddress">Adresse</label>
                <input type="text" class="form-control" id="customerAddress" [(ngModel)]="reportData.customer.address" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
            <div class="col-4 col-md-auto">
                <label for="customerZipcode">Postnr.</label>
                <input type="text" class="form-control" id="customerZipcode" [(ngModel)]="reportData.customer.zipCode" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
            <div class="col-8 col-md pl-0">
                <label for="customerCity">By</label>
                <input type="text" class="form-control" id="customerCity" [(ngModel)]="reportData.customer.city" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
        </div>
        <hr>
        <!-- Anlægsoplysninger -->
        <div class="row">
            <div class="col-12">
                <h3>Anlægsoplysninger</h3>
            </div>
            <!-- Anlægstype -->
            <div class="col-6 col-md">
                <label for="assetType">Anlægstype</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetType" (change)="reportData.assetModel = ''; reportData.assetModelInside = ''; saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="'Gaskedel'">Gaskedel</option>
                    <option [value]="'Jordvarme'">Jordvarme</option>
                    <option [value]="'Luft / luft'">Luft / luft</option>
                    <option [value]="'Luft / vand'">Luft / vand</option>
                </select>
            </div>
            <!-- Gaskeddel -->
            <div class="col-6 col-md pl-0" *ngIf="!!reportData && reportData.assetType == 'Gaskedel' && !!data.modelGas">
                <label for="assetType">Model</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetModel" (change)="reportData.assetModelInside = ''; saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="x" *ngFor="let x of data.modelGas">{{x}}</option>
                </select>
            </div>
            <!-- Jordvarme -->
            <div class="col-6 col-md pl-0" *ngIf="!!reportData && reportData.assetType == 'Jordvarme' && !!data.modelGeothermal">
                <label for="assetType">Model</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetModel" (change)="reportData.assetModelInside = ''; saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="x" *ngFor="let x of data.modelGeothermal">{{x}}</option>
                </select>
            </div>
            <!-- Luft / vand -->
            <div class="col-6 col-md pl-0" *ngIf="!!reportData && reportData.assetType == 'Luft / vand' && !!data.modelAirWater">
                <label for="assetType">Model udedel</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetModel" (change)="reportData.assetModelInside = ''; saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="x" *ngFor="let x of data.modelAirWater">{{x}}</option>
                </select>
            </div>
            <!-- Luft / luft -->
            <div class="col-6 col-md pl-0" *ngIf="!!reportData && reportData.assetType == 'Luft / luft' && !!data.modelAirWater">
                <label for="assetType">Model udedel</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetModel" (change)="reportData.assetModelInside = ''; saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="x" *ngFor="let x of data.modelAirAir">{{x}}</option>
                </select>
            </div>
            <!-- Indedel 'Compress 3000 ODU Split 2-4-6' -->
            <div class="col-6 col-md pl-0" *ngIf="!!reportData && reportData.assetType == 'Luft / vand' && !!data.modelInside && (reportData.assetModel == 'Compress 3000 ODU Split 2' || reportData.assetModel == 'Compress 3000 ODU Split 4' || reportData.assetModel == 'Compress 3000 ODU Split 6')">
                <label for="assetType">Model indedel</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetModelInside" (change)="saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="x" *ngFor="let x of data.modelInside['Compress 3000 ODU Split 2-4-6']">{{x}}</option>
                </select>
            </div>
            <!-- Indedel 'Compress 3000 ODU Split 8-11-15' -->
            <div class="col-6 col-md pl-0" *ngIf="!!reportData && reportData.assetType == 'Luft / vand' && !!data.modelInside && (reportData.assetModel == 'Compress 3000 ODU Split 8' || reportData.assetModel == 'Compress 3000 ODU Split 11' || reportData.assetModel == 'Compress 3000 ODU Split 15')">
                <label for="assetType">Model indedel</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetModelInside" (change)="saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="x" *ngFor="let x of data.modelInside['Compress 3000 ODU Split 8-11-15']">{{x}}</option>
                </select>
            </div>
            <!-- Indedel 'Bosch Compress 6000 AW-5-7-9' -->
            <div class="col-6 col-md pl-0" *ngIf="!!reportData && reportData.assetType == 'Luft / vand' && !!data.modelInside && (reportData.assetModel == 'Bosch Compress 6000 AW-5' || reportData.assetModel == 'Bosch Compress 6000 AW-7' || reportData.assetModel == 'Bosch Compress 6000 AW-9')">
                <label for="assetType">Model indedel</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetModelInside" (change)="saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="x" *ngFor="let x of data.modelInside['Bosch Compress 6000 AW-5-7-9']">{{x}}</option>
                </select>
            </div>
            <!-- Indedel 'Bosch Compress 6000 AW-13-17' -->
            <div class="col-6 col-md pl-0" *ngIf="!!reportData && reportData.assetType == 'Luft / vand' && !!data.modelInside && (reportData.assetModel == 'Bosch Compress 6000 AW-13' || reportData.assetModel == 'Bosch Compress 6000 AW-17')">
                <label for="assetType">Model indedel</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetModelInside" (change)="saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="x" *ngFor="let x of data.modelInside['Bosch Compress 6000 AW-13-17']">{{x}}</option>
                </select>
            </div>
            <!-- Indedel 'Bosch Compress CS7000iAW 13 OR-T,Bosch Compress CS7000iAW 17 OR-T' -->
            <div class="col-6 col-md pl-0" *ngIf="!!reportData && reportData.assetType == 'Luft / vand' && !!data.modelInside && (reportData.assetModel == 'Bosch Compress CS7000iAW 13 OR-T' || reportData.assetModel == 'Bosch Compress CS7000iAW 17 OR-T')">
                <label for="assetType">Model indedel</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetModelInside" (change)="saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="x" *ngFor="let x of data.modelInside['Compress 7000 17']">{{x}}</option>
                </select>
            </div>
            <!-- Indedel 'Bosch Compress CS7400iAW 5,Bosch Compress CS7400iAW 7,Bosch Compress CS7000iAW 5 OR-S,Bosch Compress CS7000iAW 7 OR-S,Bosch Compress CS7000iAW 9 OR-S' -->
            <div class="col-6 col-md pl-0" 
            *ngIf="!!reportData && reportData.assetType == 'Luft / vand' && !!data.modelInside &&  (
                reportData.assetModel == 'Bosch Compress CS7400iAW 5' || 
                reportData.assetModel == 'Bosch Compress CS7400iAW 7' ||
                reportData.assetModel == 'Bosch Compress CS7000iAW 5 OR-S' ||
                reportData.assetModel == 'Bosch Compress CS7000iAW 7 OR-S' ||
                reportData.assetModel == 'Bosch Compress CS7000iAW 9 OR-S')">
                <label for="assetType">Model indedel</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetModelInside" (change)="saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="x" *ngFor="let x of data.modelInside['Compress 7000 9']">{{x}}</option>
                </select>
            </div>
            <!-- Indedel 'EHP10AW,EHP8AW' -->
            <div class="col-6 col-md pl-0" 
            *ngIf="!!reportData && reportData.assetType == 'Luft / vand' && !!data.modelInside &&  (
                reportData.assetModel == 'EHP10AW' || 
                reportData.assetModel == 'EHP8AW')">
                <label for="assetType">Model indedel</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetModelInside" (change)="saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="x" *ngFor="let x of data.modelInside['CC160']">{{x}}</option>
                </select>
            </div>
            <!-- Indedel 'Compress 11 AWO,Compress 13 AWO,Compress 9 AWO' -->
            <div class="col-6 col-md pl-0" 
            *ngIf="!!reportData && reportData.assetType == 'Luft / vand' && !!data.modelInside &&  (
                reportData.assetModel == 'Compress 11 AWO' || 
                reportData.assetModel == 'Compress 13 AWO' ||
                reportData.assetModel == 'Compress 9 AWO')">
                <label for="assetType">Model indedel</label>
                <select class="form-control" id="assetType" [(ngModel)]="reportData.assetModelInside" (change)="saveDoc()" [disabled]="isLocked">
                    <option [value]="''">Ingen valgt</option>
                    <option [value]="x" *ngFor="let x of data.modelInside['CMO']">{{x}}</option>
                </select>
            </div>
            <!-- Serienummer udedel -->
            <div class="col-6 col-md pl-md-0 pr-md-0" *ngIf="!!reportData.assetModel">
                <label for="assetSerialNumberOutside">Serienummer udedel</label>
                <input type="text" class="form-control" id="assetSerialNumberOutside" [(ngModel)]="reportData.assetSerialNumberOutside" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
            <!-- Serienummer indedel -->
            <div class="col-6 col-md pr-md-0" *ngIf="!!reportData.assetModelInside">
                <label for="assetSerialNumberInside">Serienummer indedel</label>
                <input type="text" class="form-control" id="assetSerialNumberInside" [(ngModel)]="reportData.assetSerialNumberInside" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
            <!-- Hybridanlæg -->
            <div class="col-6 col-md">
                <label for="assetHybrid">Hybridanlæg</label>
                <input type="text" class="form-control" id="assetHybrid" [(ngModel)]="reportData.assetHybrid" (blur)="saveDoc()" [disabled]="isLocked">
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-12">
                <h3>Bemærkninger</h3>
            </div>
            <div class="col-12">
                <textarea rows="3" maxlength="150" name="assetRemarks" class="form-control" id="assetRemarks" [(ngModel)]="reportData.assetRemarks" (blur)="saveDoc()" placeholder="Evt. bemærkniger" [disabled]="isLocked"></textarea>
            </div>
        </div>
    </div>
</div>